import { imageProfileGenerator } from "../../../../utils/image/imageProfileGenerator";
import { GalleryImageObject } from "../../utils";
import { ZoomableImage } from "./ZoomableImage";
import styles from "./GalleryImageElement.module.scss";

type GalleryImageElementProps = {
  mediaItem: GalleryImageObject;
  isSelected: boolean;
  index: number;
  sizes?: string;
  fullscreen?: boolean;
  hasSuperZoom?: boolean;
};

export const GalleryImageElement = ({
  fullscreen,
  mediaItem,
  isSelected,
  index,
  hasSuperZoom,
  sizes,
}: GalleryImageElementProps) =>
  fullscreen ? (
    <ZoomableImage
      mediaItem={mediaItem}
      isSelected={isSelected}
      dataTestId={`carousel-image-${index}`}
      className={styles.galleryImage}
      loading={index > 0 ? "lazy" : "eager"}
      hasSuperZoom={hasSuperZoom}
    />
  ) : (
    <img
      src={mediaItem.imageUrl}
      alt=""
      data-testid={`carousel-image-${index}`}
      className={styles["galleryImage"]}
      sizes={sizes}
      srcSet={imageProfileGenerator(mediaItem.imageUrl)}
      loading={index > 0 ? "lazy" : "eager"}
    />
  );
